'use strict';

import './logging';
import '@babel/polyfill';
import '@mdi/font/css/materialdesignicons.min.css';
import 'typeface-roboto';
import { i18n } from './plugins/i18n';
import './plugins/i18n-extended';
import './plugins/vuetify';
import Vue from 'vue';
import router from './router';
import store from './store/index';
import Main from './Main.vue';


Vue.config.productionTip = false

new Vue({
	router,
	store,
	i18n,
	render: h => h(Main)
}).$mount('#app')
